import { formatDate, formatRange } from "@/lib/race";

const pos = (r) => (r.status !== "finished" ? r.status.toUpperCase() : r.position ? `P${r.position}` : "—");

export const RESOURCES = [
  {
    key: "results",
    title: "Risultati",
    singular: "risultato",
    fields: [
      { name: "round", label: "Round", type: "number", default: 1 },
      { name: "circuit", label: "Circuito", type: "text", required: true },
      { name: "race", label: "Gara", type: "select", options: ["Gara 1", "Gara 2", "Gara 3"], default: "Gara 1" },
      { name: "date", label: "Data", type: "date", required: true },
      { name: "grid", label: "Posizione in griglia", type: "number", nullable: true },
      { name: "position", label: "Posizione finale", type: "number", nullable: true },
      { name: "status", label: "Stato", type: "select", options: ["finished", "dnf", "dns"], default: "finished" },
      { name: "points", label: "Punti", type: "number", default: 0 },
      { name: "best_lap", label: "Giro più veloce", type: "text", placeholder: "1:42.318" },
    ],
    summary: (r) => [`R${r.round} · ${r.circuit} · ${r.race}`, `${formatDate(r.date)} · ${pos(r)} · ${r.points} pt`],
  },
  {
    key: "races",
    title: "Calendario",
    singular: "gara",
    fields: [
      { name: "round", label: "Round", type: "number", default: 1 },
      { name: "championship", label: "Campionato", type: "select", options: ["Italian F4", "E4"], default: "Italian F4" },
      { name: "circuit", label: "Circuito", type: "text", required: true },
      { name: "circuit_key", label: "Mappa circuito", type: "select", options: ["", "misano", "vallelunga", "monza", "mugello", "imola"], default: "" },
      { name: "city", label: "Città", type: "text" },
      { name: "country", label: "Paese", type: "text", default: "Italia" },
      { name: "date_start", label: "Data inizio", type: "date", required: true },
      { name: "start_time", label: "Ora inizio (countdown)", type: "time", default: "09:00" },
      { name: "date_end", label: "Data fine", type: "date" },
      { name: "length_km", label: "Lunghezza (km)", type: "text" },
      { name: "image", label: "Immagine", type: "image" },
    ],
    summary: (r) => [`R${r.round} · ${r.circuit}`, `${formatRange(r.date_start, r.date_end)} · ${r.city || ""}`],
    thumb: (r) => r.image,
  },
  {
    key: "news",
    title: "News",
    singular: "news",
    fields: [
      { name: "title", label: "Titolo", type: "text", required: true },
      { name: "title_en", label: "Titolo (English)", type: "text" },
      { name: "date", label: "Data", type: "date", required: true },
      { name: "tag", label: "Categoria", type: "text", default: "News" },
      { name: "excerpt", label: "Anteprima", type: "textarea" },
      { name: "excerpt_en", label: "Anteprima (English)", type: "textarea" },
      { name: "body", label: "Testo completo", type: "textarea" },
      { name: "body_en", label: "Testo completo (English)", type: "textarea" },
      { name: "image", label: "Immagine", type: "image" },
    ],
    summary: (r) => [r.title, `${formatDate(r.date)} · ${r.tag}`],
    thumb: (r) => r.image,
  },
  {
    key: "gallery",
    title: "Galleria",
    singular: "foto",
    fields: [
      { name: "image", label: "Foto", type: "image", required: true },
      { name: "caption", label: "Didascalia", type: "text" },
      { name: "caption_en", label: "Didascalia (English)", type: "text" },
      { name: "category", label: "Categoria", type: "select", options: ["Pista", "Paddock", "Podio", "Casco", "Lifestyle"], default: "Pista" },
    ],
    summary: (r) => [r.caption || "Foto", r.category],
    thumb: (r) => r.image,
  },
  {
    key: "sponsors",
    title: "Sponsor",
    singular: "sponsor",
    fields: [
      { name: "name", label: "Nome", type: "text", required: true },
      { name: "tier", label: "Livello", type: "select", options: ["main", "official", "partner", "supplier"], default: "partner" },
      { name: "url", label: "Sito web", type: "text", placeholder: "https://" },
      { name: "logo", label: "Logo", type: "image", keepPng: true },
    ],
    summary: (r) => [r.name, r.tier],
    thumb: (r) => r.logo,
  },
];
